import React, { memo } from 'react';
import useNotifier from '../hooks/useNotifier';

const NotificationsWrapper = ({ children }) => {
  useNotifier();

  return <>{children}</>;
};

export default memo(NotificationsWrapper);
